export default __webpack_public_path__ + "static/media/O-074.a536d28d.png";